var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
// dayjs
import advancedFormat from "dayjs/plugin/advancedFormat";
import timezonePlugin from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";
import { DATE_FORMAT, TIME_FORMAT } from "../../../../../constants";
import { Text } from "../../../../Atoms";
import { SHORT_DATE_FORMAT, SHORT_TIME_FORMAT, } from "../../../../../constants/dateTimeFormatting";
dayjs.extend(utc);
dayjs.extend(timezonePlugin);
dayjs.extend(advancedFormat);
var DateTimeDisplay = function (_a) {
    var dateTime = _a.dateTime, timezoneId = _a.timezoneId, singleDateColumn = _a.singleDateColumn, dateFormat = _a.dateFormat, textEmphasis = _a.textEmphasis, textVariant = _a.textVariant;
    if (!dateTime) {
        return _jsx(Text, { width: "60%" });
    }
    var validDate = dayjs(dateTime).isValid();
    if (singleDateColumn) {
        return (_jsx(Stack, __assign({ justifyContent: "center", pr: 4 }, { children: _jsx(Text, __assign({ variant: textVariant, emphasis: textEmphasis }, { children: validDate
                    ? dayjs(dateTime)
                        .tz(timezoneId)
                        .format(dateFormat || "".concat(SHORT_DATE_FORMAT, " ").concat(SHORT_TIME_FORMAT))
                    : "-" })) })));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Stack, __assign({ justifyContent: "center", width: "31%", pr: 12 }, { children: _jsx(Text, __assign({ emphasis: textEmphasis, variant: textVariant }, { children: validDate ? dayjs(dateTime).tz(timezoneId).format(DATE_FORMAT) : "-" })) })), _jsx(Stack, __assign({ justifyContent: "center", pr: 4, width: "31%" }, { children: _jsx(Text, __assign({ emphasis: textEmphasis, variant: textVariant }, { children: validDate ? dayjs(dateTime).tz(timezoneId).format(TIME_FORMAT) : "-" })) }))] }));
};
export default DateTimeDisplay;
